import { ApiClient } from '../../ApiClient';
import { ConnectionDTO } from '../dto/MarketplaceDTOs';
import { BolEndpoint } from '@domain/connection/enums/endpoints.enum';
import { InventorySyncEventItem } from '@domain/connection/models/InventorySyncEvent';
import { BolSyncJobStatus } from '@domain/connection/models/BolSyncJob';
import { FullSyncJob } from '@domain/connection/models/ImportJob';

const BOL_SYNC_PATHS: Record<BolEndpoint, string> = {
  [BolEndpoint.INVENTORY]: 'inventory/sync',
  [BolEndpoint.ORDERS_ALL]: 'orders/sync/all',
  [BolEndpoint.ORDERS_NEW]: 'orders/sync/new',
  [BolEndpoint.OFFERS]: 'offers/sync',
  [BolEndpoint.RANKS]: 'insights/ranks/sync',
  [BolEndpoint.SEARCH_TERMS]: 'insights/search-terms/sync',
  [BolEndpoint.INVOICES]: 'invoices/sync',
};

export class BolConnectorDataSource {

  constructor(private api: ApiClient) {
  }

  async syncBolConnection(connectionId: string, endpoint: BolEndpoint): Promise<string> {
    const response = await this.api.post<{ jobId: string }>(`/connections/bol/${BOL_SYNC_PATHS[endpoint]}?connectionId=${connectionId}`);
    return response.data.jobId;
  }

  async syncSearchTerm(connectionId: string, keyword: string): Promise<string> {
    const response = await this.api.post<{ jobId: string }>(
      `/connections/bol/insights/search-terms/sync?connectionId=${connectionId}&keyword=${encodeURIComponent(keyword)}`,
    );
    return response.data.jobId;
  }

  async fetchBolJobStatus(jobId: string): Promise<BolSyncJobStatus> {
    const response = await this.api.get<BolSyncJobStatus>(`/connections/bol/jobs/${jobId}`);
    return response.data;
  }

  async syncFull(connectionId: string): Promise<FullSyncJob[]> {
    const response = await this.api.post<{ jobs: FullSyncJob[] }>(`/connections/bol/sync/full?connectionId=${connectionId}`);
    return response.data.jobs;
  }

  async addBolMarketplaceConnection(code: string, redirectUri: string): Promise<ConnectionDTO> {
    const response = await this.api.post<ConnectionDTO>('/connections/bol', {
      code,
      redirectUri
    });
    return response.data;
  }

  async reconnect(connectionId: string, code: string, redirectUri: string): Promise<ConnectionDTO> {
    const response = await this.api.post<ConnectionDTO>(`/connections/bol/${connectionId}/reconnect`, {
      code,
      redirectUri
    });
    return response.data;
  }

  async fetchInventoryPreview(connectionId: string, source: 'offer' | 'lvb'): Promise<InventorySyncEventItem[]> {
    const path = source === 'offer'
      ? `/connections/bol/offers/inventory?connectionId=${connectionId}`
      : `/connections/bol/inventory?connectionId=${connectionId}&page=1`;
    const response = await this.api.get<InventorySyncEventItem[]>(path);
    return response.data;
  }
}
